import { SdgGoalResult } from "@/schema/assessment-results/SdgGoalResult";
import SDGGroupList from "@/src/_components/AssessmentResult/SDGGroupList";
import { useTranslation } from "react-i18next";

interface SDGIndicatorDetailsProps {
  sdgGoalResults: SdgGoalResult[];
}
export default function SDGIndicatorDetails({
  sdgGoalResults,
}: SDGIndicatorDetailsProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col rounded-[12px]
     shadow-[0px_0px_0px_1px_#00000006,_1px_2px_4px_0px_#00000014]"
    >
      <div className="my-[20px] mx-[24px]">
        <span className="text-cool-gray-900 text-[18px] leading-[28px]">
          {t("sDGs-indicator-detailed-evaluation")}
        </span>
      </div>
      {sdgGoalResults.map((item, index) => {
        return <SDGGroupList key={item.id} sdgGoalResult={item} />;
      })}
    </div>
  );
}
